import { createSlice } from "@reduxjs/toolkit";
import { fetchDefaultItems } from "./DefaultThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const defaultSlice = createSlice({
  name: "default",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchDefaultItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDefaultItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchDefaultItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default defaultSlice.reducer;